import React from 'react';
import PropTypes from 'prop-types';
import {getInitials} from 'components/SuccessManager/helpers';
import {
  AvatarBadge,
  AvatarCircle,
  AvatarWrapper
} from 'components/SuccessManager/styles';

const SIZES = {sidebar: 26, help: 56};

// The CSM's initials with the Sauce badge in the corner.
const SuccessManagerAvatar = ({manager, variant}) => (
  <AvatarWrapper size={SIZES[variant]}>
    <AvatarCircle className={variant}>{getInitials(manager)}</AvatarCircle>
    <AvatarBadge className={variant}>s</AvatarBadge>
  </AvatarWrapper>
);

SuccessManagerAvatar.propTypes = {
  manager: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired,
  variant: PropTypes.oneOf(['sidebar', 'help']).isRequired
};

export default SuccessManagerAvatar;
